import { TWEnvType } from '../helpers/environment';
import { clientKeys } from './clientKeys';

export type GrowthbookConfig = Record<
  TWEnvType,
  { apiHost: string; clientKey: string }
>;

export function getClientGrowthbookConfig(
  environment: TWEnvType
): GrowthbookConfig[TWEnvType] {
  const devConfig = {
    apiHost: 'https://mpexp.treatwell.net.dev01.twtest.io',
    clientKey: clientKeys.dev,
  };

  const urls: GrowthbookConfig = {
    dev: devConfig,
    staging: {
      apiHost: 'https://mpexp.treatwell.net.staging.twtest.io',
      clientKey: clientKeys.staging,
    },
    prod: {
      apiHost: 'https://mpexp.treatwell.net',
      clientKey: clientKeys.prod,
    },
    unknown: devConfig,
  };

  return urls[environment];
}
